import enumShow from './enum-show.vue'

enumShow.install = (Vue) =>{
  Vue.component(enumShow.name,enumShow);
}

export default {
  enumShow
};



// WEBPACK FOOTER //
// ./src/components/enum-show/index.js